import React from 'react';
import { Link, useParams } from 'react-router-dom';
import INSIGHTS from '../data/insights';

export default function InsightDetail() {
  const { id } = useParams();
  const insightIndex = Number.parseInt(id, 10);
  const insight = Number.isInteger(insightIndex) ? INSIGHTS[insightIndex] : null;

  if (!insight) {
    return (
      <section className="section" style={{ textAlign: 'center', padding: '120px 0' }}>
        <div className="container">
          <h2>Insight Not Found</h2>
          <p>The article you are looking for does not exist.</p>
          <Link to="/insights" className="btn btn-primary" style={{ marginTop: 24, display: 'inline-flex' }}>
            Back to Insights
          </Link>
        </div>
      </section>
    );
  }

  return (
    <>
      <section className="section section-soft" style={{ paddingBottom: 24 }}>
        <div className="container" style={{ maxWidth: 860 }}>
          <Link to="/insights" className="link" style={{ display: 'inline-flex', alignItems: 'center', marginBottom: 16 }}>
            <span aria-hidden="true" style={{ marginRight: 8 }}>←</span>
            <span>Back to Insights</span>
          </Link>
          <div className="card">
            <span className="insight-tag">{insight.tag}</span>
            <h1 style={{ marginTop: 12 }}>{insight.title}</h1>
            <p style={{ color: 'var(--muted)', marginBottom: 20 }}>
              Read time: {insight.readTime}
            </p>
            <p>{insight.desc}</p>
            <p style={{ marginTop: 16 }}>
              This article page is now live and linked correctly. Full editorial content can be expanded here.
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
